import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

/**
 * Custom hook to handle authentication state
 * @returns {Object} Authentication state and user information
 */
const useAuth = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (!decoded || !decoded.id) {
          throw new Error('Invalid token format');
        }
        
        setUser(decoded);
        setUserId(decoded.id);
        setIsAdmin(decoded.isAdmin || false);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error decoding token:', error);
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
        setUserId(null);
        setIsAdmin(false);
        setIsAuthenticated(false);
      }
    } else {
      setUser(null);
      setUserId(null);
      setIsAdmin(false);
      setIsAuthenticated(false);
    }
  }, [token]);

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return {
    token,
    user,
    userId,
    isAdmin,
    isAuthenticated,
    logout
  };
};

export default useAuth;
